<template>
  <component :is="component" />
</template>
<script>
import Func55ExtratoUtilizacao from '@/views/55/Func55ExtratoUtilizacao.vue'

export default {
  name: 'Func55',
  data () {
    return {
      component: Func55ExtratoUtilizacao
    }
  }
}
</script>
